export enum McbGridActionType {
  BUTTON = "button", MENU = "menu" , TOOLBAR = "toolbar"
}
